import { JobListing } from "../../../../../common/types";
import Callout from "../../../../components/Callout/Callout";
import ListItem from "../../../../components/ListItem/ListItem";

type OpenPositionsProps = {
    companyJobs: JobListing[];
};
export default function OpenPositions({ companyJobs }: OpenPositionsProps) {
    return (
        <div className="relative mb-20 max-w-screen-lg mx-auto p-6 bg-white">
            {companyJobs &&
                companyJobs.map((job) => <ListItem key={job.id} job={job} />)}
            {companyJobs.length === 0 && (
                <Callout>
                    Trenutno nema otvorenih pozicija za ovu kompaniju. <br />
                    Ukoliko imate nekoliko godina iskustva slobodno se javite
                    kompaniji, većina njih zapošljava iskusne developere i van
                    konkursa.
                </Callout>
            )}
        </div>
    );
}
